import { createContext, FC, ReactNode, useContext } from "react";
import { useDebug } from "./useDebug";

const DebugContext = createContext<ReturnType<typeof useDebug> | null>(null);

export type DebugContextType = ReturnType<typeof useDebug>;

// eslint-disable-next-line react-refresh/only-export-components
export const useDebugContext = () => {
  const context = useContext(DebugContext);
  if (!context) {
    throw new Error("useDebugContext must be used within a DebugProvider");
  }
  return context;
};

export const DebugProvider: FC<{
  children: ReactNode;
  enabled: boolean;
  variables?: Record<string, string | number | boolean>;
}> = ({ children, enabled, variables }) => {
  const debugValue = useDebug({ enabled, variables });

  return <DebugContext.Provider value={debugValue}>{children}</DebugContext.Provider>;
};
